import React, { useEffect, useState, useRef } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { relatorioAction, orgaoAction } from '../../_actions'
import PropTypes from 'prop-types'
import SearchIcon from '@mui/icons-material/Search';
import moment from 'moment'
import TitleContentInformation from '../TitleContentInformation'
import HelpIcon from '@mui/icons-material/Help';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExcel, faFilePdf } from '@fortawesome/free-solid-svg-icons'
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import { styled } from '@mui/material/styles';
import {
  Autocomplete,
  Card,
  CardContent,
  CircularProgress,
  Chip,
  FormControlLabel,
  FormControl,
  FormLabel,
  Grid,
  Paper,
  Skeleton,
  Switch,
  IconButton,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Radio,
  RadioGroup
} from '@mui/material'
import { withStyles } from '@mui/styles'
import { MANUAIS_CATEGORIAS } from '../../utils'
import { withRouter } from 'react-router-dom'
import { AccessControl } from '../../components/Utils/AccessControl'
import AccessDenied from '../Errors/AccessDenied'
import { Page } from 'components'
import {
  ValidatorForm,
  TextValidator
} from 'react-material-ui-form-validator'
import CustomButton from '../../components/CustomButton/CustomButton'
import { HelpModal } from '../../components';
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(6, 5, 6, 5)
  },
  textField: {
    fontSize: 8
  },
  table: {
    '& .MuiTableRow-root': {
      fontSize: '1rem', // Aplica ao conteúdo das linhas,
      paddingLeft: 4,
      paddingBottom: 4,
      paddingTop: 4,
      paddingRight: 3
    },
    '& .MuiTableCell-root': {
      fontSize: '1rem', // Aplica ao conteúdo das células
      paddingLeft: 4,
      paddingBottom: 4,
      paddingTop: 4,
      paddingRight: 3
    }
  },
})

const SwitchStyled = styled(Switch)(() => ({
  '& .MuiSwitch-switchBase': {
    '&.Mui-checked': {
      color: '#000',
    }
  }
}));

const RelatorioFinanceiroOrgao = (props) => {

  const dispatch = useDispatch()
  const isFirstRender = useRef(true);
  const { classes, className, ...rest } = props
  const { relatorio } = props.relatorio
  const { totalRegistros } = props.relatorio || 0
  const { isLoading } = props.relatorio

  const [filterRelatorio, setFilterRelatorio] = useState({
    empenhoPago: false,
    idOrgao: 0,
    dataInicio: '',
    dataFim: '',
    tipoData: 'cadastro',
    page: 0,
    limit: 99999999
  });

  //const [empenhoPago, setEmpenhoPago] = useState(false);
  const [valueOrgao, setValueOrgao] = useState(null);
  const [inputValueOrgao, setInputValueOrgao] = useState('');

  useEffect(() => {
    dispatch(orgaoAction.getOrgaoSelect());
    dispatch(relatorioAction.clear());
  }, []);

  useEffect(() => {
    // se é a primeira renderização, não faz a chamada
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    dispatch(relatorioAction.getRelatorioFinanceiroOrgao(filterRelatorio, true));
  }, [filterRelatorio.page, filterRelatorio.limit]);

  const getTodayDate = (): string => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };

  const [modalHelp, setModalHelp] = useState(false);
  const toggleModalHelp = () => setModalHelp(!modalHelp);

  const handleOpenModalHelp = () => {
    toggleModalHelp();
  }

  //const [page, setPage] = useState(0);
  //const [limit, setLimit] = useState(10);

  const [ready, setReady] = React.useState(false);

  const { usuarioOrgao } = useSelector(
    (state) => state.usuarioOrgao
  )

  var options = usuarioOrgao.map(u => ({ id: u.orgao?.id, nome: u.orgao?.nome?.toUpperCase() }));

  console.log(options)

  //const { orgao } = useSelector(
    //(state) => state.orgao)

  //const optionsOrgaos = options.map(u => ({ id: u.value, nome: u.text }));

  let filterModel = {
    EmpenhoPago: filterRelatorio.empenhoPago,
    IdOrgao: filterRelatorio.idOrgao,
    Page: filterRelatorio.page,
    DataInicio: filterRelatorio.dataInicio,
    DataFim: filterRelatorio.dataFim,
    Limit: filterRelatorio.limit,
    TipoData: filterRelatorio.tipoData
  };

  const handlePrint = () => {
    const queryParams = new URLSearchParams(filterModel).toString();
    console.log('queryParams =>', queryParams)
    if (queryParams) {
      window.open(`/relatorioFinanceiroOrgaoPrint?${queryParams}`, '_blank');
    }
  }

  const handleExportExcel = () => {

    const modifiedFilterModel = {
      ...filterModel,
      Limit: 9999999
    };

    dispatch(relatorioAction.getRelatorioFinanceiroOrgaoArquivo(modifiedFilterModel));
  }

  const handleSubmit = (event) => {
    console.log('filterModel =>', filterModel)
    dispatch(relatorioAction.getRelatorioFinanceiroOrgao(filterModel, true));
  }

  const handleOpenArquivo = (link) => {
    window.open(link, '_blank');
  }

  const groupedRelatorio = relatorio && relatorio.length > 0 && relatorio?.reduce((acc, item) => {
    const key = item.orgao;
    if (!acc[key]) {
      acc[key] = { items: [], total: 0 };
    }
    acc[key].items.push(item);
    acc[key].total += item.valor || 0;
    return acc;
  }, {});

  return (
    <Page className={classes.root} title="Relatório - Financeiro por Orgão">
      <AccessControl
        rule={'relatorios.list'} //permissão necessária para acessar conteúdo
        yes={() => (
          <Grid
            {...rest}
            container
            spacing={2}
          >
            <Grid item lg={12} md={12} xl={12} xs={12}>
              <Card style={{ marginBottom: 10, marginTop: 0 }}>
                <ValidatorForm
                  id="formRelatorio"
                  onSubmit={(event) => handleSubmit(event)}
                >
                  <CardContent>
                    <Grid container style={{ display: 'flex', flexDirection: 'row', alignItems: 'end' }}>
                      <TitleContentInformation
                        subTitle={'RELATÓRIO'}
                        title={'Relatório Financeiro por Orgão'}
                      />
                      <Grid item lg={1} md={1} xl={1} xs={12}>
                        <IconButton
                          aria-label="Ajuda"
                          component="a"
                          onClick={() =>
                            handleOpenModalHelp()
                          }
                          size="small"
                        >
                          <Tooltip title={'Ajuda'}>
                            <Tooltip>
                              <HelpIcon sx={{ float: 'center', color: '#000' }} fontSize='medium' />
                            </Tooltip>
                          </Tooltip>
                        </IconButton>
                      </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid item lg={5} md={5} xl={5} xs={12} style={{ marginTop: 17 }}>
                        <Autocomplete
                          value={valueOrgao}
                          onChange={(event, newValue) => {
                            setValueOrgao(newValue);
                            setFilterRelatorio({
                              ...filterRelatorio,
                              idOrgao: newValue?.id || 0
                            });
                          }}
                          inputValue={inputValueOrgao}
                          onInputChange={(event, newInputValueOrgao) => {
                            setInputValueOrgao(newInputValueOrgao);
                          }}
                          id="controllable-states-demo"
                          options={options}
                          getOptionLabel={(optionOrgao) => optionOrgao?.nome || ''}
                          renderInput={(params) => (
                            <TextField {...params} label="Órgão *... " fullWidth />
                          )}
                          fullWidth
                        />
                      </Grid>
                      <Grid item lg={3} md={3} xl={3} xs={12} style={{ display: 'flex', justifyContent: 'start', alignItems: 'center', marginBottom: 5, paddingBottom: 10 }}>
                        <FormControlLabel
                          control={
                            <SwitchStyled
                              color="default"
                              checked={filterRelatorio.empenhoPago}
                              onChange={() => setFilterRelatorio({ ...filterRelatorio, empenhoPago: !filterRelatorio.empenhoPago })}
                            />
                          }
                          label="Filtrar Apenas Empenhos Pagos"
                        />
                      </Grid>               
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid item xl={12} lg={12} md={12} xs={12} style={{ marginTop: 10 }}>
                        <FormControl component="fieldset">
                          <FormLabel component="legend">Filtrar por:</FormLabel>
                          <RadioGroup
                            row         
                            value={filterRelatorio.tipoData || 'cadastro'}
                            onChange={(e) =>
                              setFilterRelatorio({ ...filterRelatorio, tipoData: e.target.value })
                            }
                          >
                            <FormControlLabel value="cadastro" control={<Radio />} label="Data de Cadastro" />
                            <FormControlLabel value="pagamento" control={<Radio />} label="Data de Pagamento" />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xl={2} lg={2} md={2} xs={12}>
                        <TextValidator
                          className={classes.textField}
                          fullWidth
                          id="data"
                          InputLabelProps={{
                            shrink: true
                          }}
                          type="date"
                          label="Data Início"
                          margin="normal"
                          validators={['required']}
                          errorMessages={['Campo obrigatório!']}
                          onChange={(e) => setFilterRelatorio({ ...filterRelatorio, dataInicio: e.target.value })}
                          value={filterRelatorio.dataInicio || ''}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xl={3} lg={3} md={3} xs={12}>
                        <TextValidator
                          className={classes.textField}
                          fullWidth
                          id="data"
                          InputLabelProps={{
                            shrink: true
                          }}
                          type="date"
                          label="Data Fim"
                          margin="normal"
                          onChange={(e) => setFilterRelatorio({ ...filterRelatorio, dataFim: e.target.value })}
                          value={filterRelatorio.dataFim || ''}
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={2} style={{ alignItems: 'center', justifyContent: 'left', alignContent: 'left' }}>
                      <Grid item xl={12} lg={12} md={12} xs={12} style={{
                        alignItems: 'bottom',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'right',
                        textAlign: 'right'
                      }}>
                        <Grid>
                          <CustomButton
                            type="submit"
                            variant="contained"
                            dark={true}
                            disabled={props.relatorio.isLoading}
                            startIcon={<SearchIcon />}
                            endIcon={props.relatorio.isLoading && <CircularProgress size={24} />}
                          >
                            {props.relatorio.isLoading ? 'Pesquisando...' : 'Pesquisar'}
                          </CustomButton>
                        </Grid>
                        <Grid>
                          <CustomButton
                            type="submit"
                            onClick={() => handlePrint()}
                            variant="outlined"
                            endIcon={<FontAwesomeIcon icon={faFilePdf} style={{ verticalAlign: 'middle' }} />}
                          >
                            Gerar PDF
                          </CustomButton>
                        </Grid>
                        <Grid>
                          <CustomButton
                            type="button"
                            onClick={() => handleExportExcel()}
                            variant="outlined"
                            endIcon={<FontAwesomeIcon icon={faFileExcel} style={{ verticalAlign: 'middle' }} />}
                          >
                            Exportar para Excel
                          </CustomButton>
                        </Grid>
                      </Grid>
                    </Grid>
                  </CardContent>
                </ValidatorForm>
                <TableContainer component={Paper}>
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell><strong>EMPRESA</strong></TableCell>
                        <TableCell><strong>ARQUIVO</strong></TableCell>
                        <TableCell><strong>NOTA</strong></TableCell>
                        <TableCell><strong>DATA PAGAMENTO</strong></TableCell>
                        <TableCell align="right"><strong>VALOR</strong></TableCell>
                        <TableCell align="right"></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {relatorio && relatorio.length > 0 ? Object.keys(groupedRelatorio).map((group) => (
                        <React.Fragment key={group}>
                          {/* Linha de cabeçalho para o grupo */}
                          <TableRow>
                            <TableCell colSpan={7} style={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>
                              {group}
                            </TableCell>
                            <TableCell style={{ backgroundColor: '#f5f5f5' }}></TableCell>
                          </TableRow>
                          {/* Linhas de dados do grupo */}
                          {groupedRelatorio[group].items.map((n) => (
                            <>
                              <TableRow hover key={n.id}>
                                <TableCell>{n.nomeEmpresa?.toUpperCase() || ''}</TableCell>
                                <Tooltip title={n.caminhoArquivo && "Clique aqui para abrir o arquivo em uma nova aba"}>
                                  <TableCell component="th" scope="row" style={{ cursor: n.caminhoArquivo ? 'pointer' : 'default' }} onClick={() => handleOpenArquivo(n.caminhoArquivo)}>
                                    {n.caminhoArquivo ? <InsertDriveFileOutlinedIcon style={{
                                      cursor: 'pointer',
                                      fontSize: '1.5em'
                                    }} /> : '-'}
                                  </TableCell>
                                </Tooltip>
                                <Tooltip title={n.caminhoNotaFiscal && "Clique aqui para abrir o arquivo em uma nova aba"}>
                                  <TableCell component="th" scope="row" style={{ cursor: n.caminhoNotaFiscal ? 'pointer' : 'default' }} onClick={() => handleOpenArquivo(n.caminhoNotaFiscal)}>
                                    {n.caminhoNotaFiscal ? <InsertDriveFileOutlinedIcon style={{
                                      cursor: 'pointer',
                                      fontSize: '1.5em'
                                    }} /> : '-'}
                                  </TableCell>
                                </Tooltip>
                                <TableCell>
                                  {n.dataPagamento || ''}
                                </TableCell>
                                <TableCell align="right">{n.valor ? `R$${n.valor.toLocaleString('pt-br', { minimumFractionDigits: 2 })}` : '-'}</TableCell>
                              </TableRow >
                            </>
                          ))}
                          <TableRow>
                            <TableCell style={{ fontWeight: 'bold', fontSize: '1rem' }}>
                              VALOR TOTAL DO ÓRGÃO: {`R$ ${groupedRelatorio[group].total.toLocaleString('pt-br', { minimumFractionDigits: 2 })}`}
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      ))
                        :
                        (isLoading ?
                          Array.apply(null, { length: 6 }).map((e, i) => (
                            <TableRow hover>
                              <TableCell component="th" scope="row">
                                <Skeleton animation="wave" />
                              </TableCell>
                              <TableCell component="th" scope="row">
                                <Skeleton animation="wave" />
                              </TableCell>
                              <TableCell component="th" scope="row">
                                <Skeleton animation="wave" />
                              </TableCell>
                              <TableCell component="th" scope="row">
                                <Skeleton animation="wave" />
                              </TableCell>
                              <TableCell component="th" scope="row">
                                <Skeleton animation="wave" />
                              </TableCell>
                              <TableCell component="th" scope="row">
                                <Skeleton animation="wave" />
                              </TableCell>
                              <TableCell component="th" scope="row">
                                <Skeleton animation="wave" />
                              </TableCell>
                              <TableCell component="th" scope="row">
                                <Skeleton animation="wave" />
                              </TableCell>
                              <TableCell component="th" scope="row">
                                <Skeleton animation="wave" />
                              </TableCell>
                            </TableRow>
                          ))
                          :
                          <TableRow>
                            <TableCell rowSpan={6} colSpan={8} align="center">Nenhum registro encontrado</TableCell>
                          </TableRow>
                        )
                      }
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card>
            </Grid>
            {
              (modalHelp ?
                <HelpModal
                  toggle={toggleModalHelp}
                  modal={modalHelp}
                  props={props}
                  tela={MANUAIS_CATEGORIAS.RELATORIO_SERVICO_REALIZADO}
                />
                :
                null
              )
            }
          </Grid>
        )
        }
        no={() => <AccessDenied />}
      />
    </Page >
  )
}
RelatorioFinanceiroOrgao.propTypes = {
  classes: PropTypes.object.isRequired
}
const mapStateToProps = (state) => {
  return {
    relatorio: state.relatorio
  }
}
const connectedRelatorioFinanceiroOrgaoPage = withRouter(
  connect(mapStateToProps, null, null)(withStyles(styles)(RelatorioFinanceiroOrgao))
)

export { connectedRelatorioFinanceiroOrgaoPage as RelatorioFinanceiroOrgao }

